import React from 'react';
import ReactDOM from 'react-dom';
import { Button, Table, Row, Col, Panel } from 'react-bootstrap';
import UserPanel from '../../components/UserPanel';
import { salesforce_users } from '../../lib/Helpers';
import { EditModal, WaitlistModal } from '../../components/Modals';
import DateHelpers from '../../lib/DateHelpers';
import CreateUniversalCodeButton from './CreateUniversalCodeButton';
import { createUniversalCode } from '../../lib/UniversalCodes';
import { CreateUniversalCodeModal } from '../../components/Modals';

class ImagePopup extends React.Component {
  state = {
    loading: true,
    messages: []
  };

  getStyles() {
    return {
      container: {
        position: 'fixed',
        width: '100%',
        top: '0px',
        left: '0px',
        height: '100%',
        backgroundColor: 'rgba(0,0,0,0.5)',
        padding: '100px'
      },
      inner_container: {
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        flexDirection: 'column',
        overflowY: 'scroll',
        alignItems: 'center'
      }
    };
  }

  componentDidMount() {
    ReactDOM.findDOMNode(this.refs.imageContainer).focus();
  }

  handleKeyDown(e) {
    if (e.keyCode == 27) {
      this.props.hideModal();
    }
  }

  render() {
    console.log(this.props.images);
    var styles = this.getStyles();
    return (
      <div
        ref={'imageContainer'}
        tabIndex="0"
        onKeyDown={this.handleKeyDown.bind(this)}
        style={styles.container}
      >
        <div style={styles.inner_container}>
          <Button
            onClick={e => {
              this.props.hideModal();
            }}
          >
            Close x
          </Button>
          {this.props.images.map((image, index) => {
            console.log(image);
            return <img key={'image' + index} src={image.url} />;
          })}
        </div>
      </div>
    );
  }
}

class WaitlistUsersContainer extends React.Component {
  static defaultProps = {
    users: []
  };

  state = {
    assignees: [],
    waitlist_images: [],
    showing_image_popup: false
  };

  componentDidMount() {
    this.loadAssignees();
  }

  loadAssignees() {
    salesforce_users().then(
      function(result) {
        const salesforce_user_array = result.salesforce_users;
        const assignees = salesforce_user_array.map(salesforce_user => {
          let keys = Object.keys(salesforce_user);
          return { id: salesforce_user[keys[0]], name: keys[0] };
        });
        this.setState({
          assignees: [{ id: null, name: 'None' }].concat(assignees)
        });
      }.bind(this)
    );
  }

  showEditModal(title, message, saveAction = function() {}) {
    this.refs.modal.show(title, message, saveAction);
  }

  showWaitlistModal(mcURL, saveAction = function() {}) {
    this.refs.waitlistModal.show(mcURL, saveAction);
  }

  showImageModal(album) {
    this.setState({
      showing_image_popup: true,
      waitlist_images: album
    });
  }

  showCreateUniversalCodeModal = maxRedeems => {
    this.refs.createUniversalCodeModal.show(maxRedeems);
  };

  render() {
    const self = this;
    return (
      <Row className="show-grid">
        <CreateUniversalCodeButton
          onClick={this.showCreateUniversalCodeModal}
        />
        <CreateUniversalCodeModal ref="createUniversalCodeModal" saveAction={maxRedeems => createUniversalCode(maxRedeems)} />
        <Table striped bordered condensed hover>
          <thead>
            <tr>
              <th>Profile Image</th>
              <th>Name</th>
              <th>Profile</th>
              <th>Job</th>
              <th>Email</th>
              <th>Phone Number</th>
              <th>Website</th>
              <th>IG</th>
              <th>Bio</th>
              <th>Images</th>
              {/*<th>Assignee</th>*/}
              <th>Bucket</th>
              {/*<th>Profile Status</th>*/}
              <th>Let Off Waitlist</th>
              <th>Join Date</th>
              <th>User Profile</th>
              <th>MDC Profile</th>
              <th>Referrer</th>
            </tr>
          </thead>
          <tbody>
            {this.props.users.map(user => {
              return (
                <UserPanel
                  key={user.swipecast_user_id}
                  assignees={self.state.assignees}
                  user={user}
                  showEditModal={self.showEditModal.bind(this)}
                  showWaitlistModal={self.showWaitlistModal.bind(this)}
                  showImageModal={self.showImageModal.bind(this)}
                />
              );
            })}
            {
              // <tr>
              //   <td>{user.referrer? user.referrer.first_name + ' ' + user.referrer.last_name:''}</td>
              //   <td>{user.waitlist_entry.mc_url ? user.waitlist_entry.mc_url : ""}</td>
              //   <td>{user.first_name}</td>
              //   <td>{user.last_name}</td>
              //   <td>{user.email}</td>
              //   <td>{DateHelpers.timeStampToLabel(user.created_at.replace(" ", "T"), true)}</td>
              //   <td>{user.profiles[0].profile_type}</td>
              //   <td>{user.instagram}</td>
              //   <td>{user.instagram_followers}</td>
              //   <td>{user.job_title}</td>
              //   <td>{user.organization}</td>
              //   <td style = {{minWidth: '600px'}}>{user.bio}</td>
              // </tr>
            }
          </tbody>
        </Table>
        <EditModal ref="modal" title="Error" message="" buttonText="Close" />
        <WaitlistModal
          ref="waitlistModal"
          title="Error"
          message=""
          buttonText="Close"
        />
        {this.state.showing_image_popup == true && (
          <ImagePopup
            images={this.state.waitlist_images}
            hideModal={() => {
              this.setState({ showing_image_popup: false });
            }}
          />
        )}
      </Row>
    );
  }
}

export default WaitlistUsersContainer;
